<template>
    <v-container>
        <ws-page
        v-bind="imtr"
        />
      <br>
      <br>
        <v-footer
          id="program-footer"
          color="primary"
          dark
          min-height="72"
          class="hidden-md-and-up"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="d-flex flex-wrap justify-md-start justify-center justify-md-none">
                  <template v-for="(s, i) in workshopsfooter">
                    <router-link
                      :key="s.name"
                      class="white--text pa-1 pa-md-0"
                      :to="s.url"
                      v-text="s.name"
                    />

                    <v-responsive
                      v-if="i < workshopsfooter.length - 1"
                      :key="`divider-${s.name}`"
                      class="mx-4 shrink hidden-sm-and-down"
                      max-height="24"
                    >
                      <v-divider vertical />
                    </v-responsive>
                  </template>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-footer>
      </v-container>
</template>

<script>
  import WsPage from '../../components/base/WsPage.vue'
  export default {
  components: { WsPage },
    name: 'Imtr',

    data: () => ({
      isMobile: false,
      workshopsfooter: [
        {
          name: 'Fringe Workshops',
          url: 'fringe-workshops',
        },
        {
          name: 'AI-Treats',
          url: 'ai-treats',
        },
        {
          name: 'eARTS',
          url: 'e-arts',
        },
        {
          name: 'IMTR',
          url: 'imtr',
        },
      ],
      imtr: {
        title: 'Workshop on Intelligent Methods for Test and Reliability (IMTR\'23)',
        website: 'https://www.gs-imtr.uni-stuttgart.de/imtr23/',
        abstract: 'Data collected during different test-related design, manufacturing and operation steps bear huge potential that is heavily under-utilized today. As a consequence, test methods are undergoing a transformation triggered by the advent of next-generation artificial intelligence and data science technology. This workshop aims at bringing the core test community together with interdisciplinary researchers working on various facets of intelligent methods within the test flow. It is underpinned by the Graduate School on Intelligent Methods for Test and Reliability (GS-IMTR) that had been jointly established by Advantest and University of Stuttgart in 2019, to give a major impetus on applied semiconductor test and reliability research. GS-IMTR currently funds ten projects covering the complete test flow, from post-silicon validation and characterization to system-level test and in-field operation. It includes groups working on Computer Science and Electrical Engineering topics ranging from data science and visualization technology to software engineering and radio frequency circuit design. This workshop will leverage the interdisciplinary potentials to consider intelligent methods for test-related problems from the points of view of both: the ETS community and researchers working in different scientific areas',
        chairs: '<strong>General Chairs:</strong> Dirk Pflueger (University of Stuttgart), Matthias Sauer (Advantest Europe) and Matteo Sonza Reorda (Politecnico di Torino) <br> <strong>Program Chairs:</strong> Hussam Amrouch (University of Stuttgart), Krishnendu Chakrabarty (Duke University), Said Hamdioui (TU Delft) and Ilia Polian (University of Stuttgart)',
        dates: [
          {
          name: 'Workshop Papers submission deadline',
          date: '<s>28 February 2023</s> <strong>20 March 2023</strong> <span style="color: red;">(Extended Deadline)</span>',
          },
          {
            name: 'Authors notification',
            date: '1 April 2023',
          },
        ],
        image: require('@/assets/imtrpng.png'),
      },
    }),
    mounted() {

    },
    methods: {
      isMobileDevice () {
        return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
    },
  }
</script>
